import {
  AccountRelationship,
  AccountType,
} from '@rematter/frontend-lib-api-client';
import { Badge, Maybe } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';

export type AccountTypeBadgeProps = { type: AccountType };

export const AccountTypeBadge = ({ type }: AccountTypeBadgeProps) => (
  <Badge
    color={type === 'Commercial' ? 'rust' : 'olive'}
    className="@AccountTypeBadge"
  >
    {type}
  </Badge>
);

export type AccountRelationshipBadgesProps = {
  relationship: Maybe<
    Pick<AccountRelationship, 'isCustomer' | 'isSupplier' | 'isCarrier'>
  >;
};

export const AccountRelationshipBadges = ({
  relationship,
}: AccountRelationshipBadgesProps) => {
  const t = useTranslations();

  return (
    <div className="@AccountRelationshipBadges flex gap-1">
      {relationship?.isCustomer && (
        <Badge color="olive">{t.accountsView.relationship.customer}</Badge>
      )}
      {relationship?.isSupplier && (
        <Badge color="rust">{t.accountsView.relationship.supplier}</Badge>
      )}
      {relationship?.isCarrier && (
        <Badge color="teal">{t.accountsView.relationship.carrier}</Badge>
      )}
    </div>
  );
};
